export const BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:9001'
  : 'https://beta-api.trustchat.com';
export const API_TYPE = 'trustchat-backend-service';
export const VERSION = 'v1';
export const ROOT_URL = `${BASE_URL}/${API_TYPE}/${VERSION}`;
